export default "__VITE_ASSET__70433491__"